import { render, staticRenderFns } from "./bind-mobile.vue?vue&type=template&id=332f3f4e"
import script from "./bind-mobile.vue?vue&type=script&lang=js"
export * from "./bind-mobile.vue?vue&type=script&lang=js"
import style0 from "./bind-mobile.vue?vue&type=style&index=0&id=332f3f4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports